module.exports = __webpack_public_path__ + "img/faqs_chademo.4b9b389f.png";